module.exports = __webpack_public_path__ + "img/34.75770e1a.jpg";